import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders } from '@angular/compiler/src/core';
import { AuthService } from './services';
import { AuthGuard } from './guards';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { HttpConfigInterceptor } from './services';
import { CanDeactivateGuard } from './guards/can-deactivate.guard';
import { NgxPlaidLinkModule } from 'ngx-plaid-link';

@NgModule({
  declarations: [],
  imports: [
    NgxPlaidLinkModule,
    CommonModule
  ],
  exports: [
    HttpClientModule
  ]
})

export class CoreModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: CoreModule,
            providers: [
                AuthService,
                AuthGuard,
                CanDeactivateGuard,
                { 
                    provide: HTTP_INTERCEPTORS, 
                    useClass: HttpConfigInterceptor, 
                    multi: true 
                }
            ]
        }
    }
    static forChild(): ModuleWithProviders {
        return {
            ngModule: CoreModule,
            providers: [
                { 
                    provide: HTTP_INTERCEPTORS, 
                    useClass: HttpConfigInterceptor, 
                    multi: true 
                }
            ]
        }
    }
}
